var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 44.9219L2.92969 0H46.9727L42.9688 44.9219L25 50",
    fill: "#264DE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 3.61328V46.0938L39.5508 42.0898L42.9688 3.61328",
    fill: "#2965F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1328 9.17969H25V14.6484H11.6211M12.1094 20.3125H25V25.8789H12.5977M12.8906 28.6133H18.3594L18.75 33.0078L25 34.668V40.4297L13.5742 37.3047",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 20.3125V25.8789H31.7383L31.0547 33.0078L25 34.668V40.4297L36.2305 37.3047L38.7695 9.17969H25V14.6484H32.8125L32.2754 20.3125H25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.9f7032740957ec70909a5fb9f5a65c33.svg";
export { ForwardRef as ReactComponent };